import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function IntrinsicIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.87822 3.12086L3.12087 9.87822C1.94929 11.0498 1.94929 12.9493 3.12086 14.1209L9.87822 20.8782C11.0498 22.0498 12.9493 22.0498 14.1209 20.8782L20.8782 14.1209C22.0498 12.9493 22.0498 11.0498 20.8782 9.87822L14.1209 3.12087C12.9493 1.94929 11.0498 1.94929 9.87822 3.12086ZM10.9389 4.18152L4.18153 10.9389C3.59574 11.5247 3.59574 12.4744 4.18152 13.0602L10.9389 19.8176C11.5247 20.4033 12.4744 20.4033 13.0602 19.8176L19.8176 13.0602C20.4033 12.4744 20.4033 11.5247 19.8176 10.9389L13.0602 4.18153C12.4744 3.59574 11.5247 3.59574 10.9389 4.18152Z"
        fill="currentColor"
      />
      <path
        d="M6.54032 10.6956L10.6955 6.54032C11.416 5.81989 12.584 5.81989 13.3044 6.54032L17.4597 10.6956C18.1801 11.416 18.1801 12.584 17.4597 13.3045L13.3044 17.4597C12.584 18.1801 11.416 18.1801 10.6955 17.4597L6.54031 13.3045C5.81989 12.584 5.81989 11.416 6.54032 10.6956Z"
        fill="currentColor"
      />
    </svg>
  )
}
